export const langCn = {
    ticketLgy: {
        AuditResult: '审核结果',
        ExcepQuestion: '异常问题',
        ExcepAnswer: '异常选项',
        TicketsTotal: '工单数汇总',
        Invalid: "失效",
        Effected: "生效",
        Unblock: "解封",
        Status: "用户状态",
        Normal: "正常",
        invalid: "无效",
        Block: "封禁",
        Success: "成功",
        Failed: "失败",
        TicketTag: "工单标签",
        PartialCompletionTime: "部分完成时间",
        GoogleVerification: "二次验证",
        Active: "已开启",
        Di: "未开启",
        Outsourcingornot: "用户类型",
        LocalCollection: "内催",
        Outsourcing: "委外",
        All: "全部",
        PhoneVerify: "电核",
        plschoose: "请选择",
        plsinputID: "请输入ID",
        TotalRepayment: "分案本金",
        UserRepaymentIntoAccount: "用户还款入账",
        UserRpaymentTime: "用户还款入账时间",
        Rollover: "展期入账",
        RolloverTime: "展期入账时间",
        CouponCredited: "优惠券入账",
        CouponCreditTime: "优惠券入账时间",
        DeductionCredited: "减免入账",
        DeductionCreditedTime: "减免入账时间",
        OtherEntry: "其他入账",
        OtherEntryTime: "其他入账时间",
        ButtonManagement: "按钮管理",
        ListManagement: "列表管理",
        Button: "按钮",
        Authority: "权限",
        Add: "添加",
        Edit: "编辑",
        Delete: "删除",
        RouteList: "路由列表",
        addaFirstLevelPage: "新增一级页面",
        Save: "保存",
        AddCallList: "新增呼叫List",
        ListOrderConfiguration: "列表顺序配置",
        ListOrder: "List顺序",
        ListList: "List列表",
        AutoDial: "自动拨号",
        Stop: "停止自动拨号",
        DialID: "拨打ID",
        NextCallTime: "下次拨打时间",
        Approve: "通过",
        Fail: "不通过",
        Invalidation: "失效",
        RejectAnApplication: "拒贷",
        BasicInformation: "基础信息",
        OrderTag: "订单标签",
        ManualReview: "人工审核",
        PhoneReview: "电话审核",
        ContactInformationAudit: "联系人信息审核",
        CustomerInformationAudit: "客户信息审核",
        AuditCompleted: "审核完成",
        LaterProcessing: "稍后处理",
        Male: "男",
        Female: "女",
        Secrecy: "保密",
        OutCall: "外呼",
        SaveCallLog: "保存通话记录",
        DialingMethod: "拨打方式",
        InSystem: "系统内",
        OutsideSystem: "系统外",
        QualityInspectionResults: "质检结果",
        QualityInspectionNotes: "质检备注",
        TelemarketingDistribution: "电销分配"

    },
    formLgy: {
        Supplier: "供应商",
        ExtensionNumber: "分机号码",
        Name: "员工姓名",
        RoleList: "角色列表",
        TicketCategory: "工单类型",
        QueryDimension: "查询维度",
        Date: "日期",
        Coupon: "优惠券",
        ButtonSelection: "按钮选择",
        Routing: "路由选择",
        Aging: "账龄",
        QueueSorting: "队列排序",
        ListCallOrder: "List呼叫顺序",
        TicketMaxWorkingNumberHistory: "员工历史最大负载量",
        EffectiveDate: "生效日期",
        TicketCrowdRoleGroup: "接单人群（角色组）",
        TicketCrowdRoleGroup2: "角色组:",
        TotalTickets: "工单总量:",
        LeftTicket:'分配后剩余单量:',
        orderTags: '标签',
    },
    tableLgy: {
        AverageCallVolume: "拨打量平均值",
        AverageConnectionAmount: "接通量平均值",
        EmployeeRole: "员工角色",
        Leader: "大组长",
        Groupleader: "小组长",
        ConnectedRate: "接通率",
        CallMedian: "通话中位数",
        RegistrationTime: "注册时间",
        LastLoginTime: "最后一次登陆时间",
        PageName: "页面名称",
        ButtonBame: "按钮名称",
        RouteName: "路由名称",
        Route: "路由",
        Value: "值",
        AutoCall: "自动呼叫",
        ManualCall: "手动呼叫",
        CallMode: "呼叫模式",
        RuleNumber: "规则编号",
        RuleName: "规则名",
        RuleDetails: "规则详情"
    },
    menuLgy: {
        ResultStatistics:'催记结果统计报表',
        OverdueReasonStat:'逾期原因统计报表',
        CallRecordData: "外呼数据统计报表",
        CollectionPerformanceDetails: "催收绩效明细",
        RememberStatistics: "催记统计报表",
        SelectCouponTemplate: "请选择优惠券模板",
        PageManagement: "页面管理",
        RouteManagement: "路由管理",
        MenuList: "菜单列表",
        MenuDetails: "菜单详情",
        CallSequenceConfiguration: "呼叫顺序配置",
        EmployeeReviewDetails: "员工审核详情",
        CustomerInformation: "客户信息",
        Audit: "审核",
        DistributionRules: "电销分单"
    },
    tipsLgy: {
        EnterPageName: "请输入页面名称",
        EnterRouteName: "请输入路由名称",
        ConfirmDelete: "确定删除",
        EnterRouteValue: "请输入路由值",
        SelectButton: "请选择按钮",
        SelectRoute: "请选择路由",
        CallSequenceConfiguration: "呼叫顺序配置",
        EnterNumber: "请输入数字,数字,数字...",
        NotPTPAndNextCallTime: "请不要同时填写PTP时间和下次通话时间",
        NextCallTimeTips: "如果已经保存PTP，请不要填写此内容",
        SelectPerson: "请选择拨打对象",
        SelectCallTime: "请选择拨打时间",
        SelectWhetherConnect: "请选择是否接通",

    }
};
